///
/// EarthBrowser
///
/// Created by Matt Giger on 3/16/2024
/// Copyright (c) 2024 Geodata Labs
///

export type FontStyle = 'normal' | 'italic' | 'oblique' | 'bold'

export type FontWeight = 'normal' | 'bold' | 'bolder' | 'lighter'

export enum FontFamily {
	monospace = "Courier New, Courier, monospace",
	sansserif = "Open Sans, Arial, Verdana, Helvetica",
	serif = "Noto Serif, Times New Roman, Times, serif",
	fantasy = "Noto Sans, Comic Sans MS, cursive, fantasy",
	script = "Noto Sans, Brush Script MT, Brush Script Std, cursive"
}

export class Font {
	// A single default instance is fine since it's immutable
	private static _default: Font | null = null

	public static get default(): Font {
		if(!Font._default) {
			Font._default = new Font(FontFamily.sansserif, 16)
		}
		return Font._default
	}

	public static destroy(): void {
		Font._default = null
	}

	public readonly family: FontFamily
	public readonly size: number
	public readonly weight: FontWeight
	public readonly style: FontStyle

	constructor(family: FontFamily, size: number, weight: FontWeight = 'normal', style: FontStyle = 'normal') {
		this.size = size
		this.family = family
		this.weight = weight
		this.style = style
	}

	public toString(): string {
		return `${this.style} ${this.weight} ${this.size}px ${this.family}`
	}
}